import {
  APIBookmarkAttributes,
  AssetType,
  UnpersistedEntity,
} from '@ardoq/api-types';
import { crudApi, renameEntity } from './api';
import { assetApi } from './assetApi';

const pathFragment = 'bookmark';

export const bookmarkApi = {
  rename: renameEntity(pathFragment),
  ...crudApi<APIBookmarkAttributes>(pathFragment),
  createInFolder: (
    attributes: UnpersistedEntity<APIBookmarkAttributes>,
    folderId: string
  ) => assetApi.createInFolder(attributes, folderId, AssetType.BOOKMARK),
};
